// extracted by mini-css-extract-plugin
module.exports = {"panel":"landingPage_panel__mspk0","headingBox":"landingPage_headingBox__raqfU","heading":"landingPage_heading__2Bcgm","cardGrid":"landingPage_cardGrid__stmx9"};